import data from '../testData.json';

const boardId = 'crrfm17jtf3k3sh';

export const getBoardId = function () {
    return boardId;
};
export const getTestBoardInfo = function () {
    return data.bugData.metaData.boards[boardId];
};
export const getSavedDashboardData = function (requestName) {
    const requestData = data.bugData.savedRequests.dashboard[requestName];
    return requestData;
};
export const getSavedRequestData = function (requestName) {
    return data.bugData.savedRequests[requestName];
};
export const getTestMetaData = function () {
    const meta = data.bugData.metaData;
    return {data: meta};
};
